import React from 'react';
import type { ClientConfig } from './types';
import { useFeatureFlags } from './FeatureFlagsContext';

type FlagName = keyof ClientConfig;

type FeatureGateProps = {
  flag: FlagName;
  children: React.ReactNode;
  fallback?: React.ReactNode;
  /** By default we don't render while flags are loading. */
  showWhileLoading?: boolean;
};

export default function FeatureGate({
  flag,
  children,
  fallback = null,
  showWhileLoading = false,
}: FeatureGateProps) {
  const { flags, loading } = useFeatureFlags();

  if (loading && !showWhileLoading) return null;

  return flags[flag] ? <>{children}</> : <>{fallback}</>;
}
